import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-fiqh',
  templateUrl: './add-fiqh.component.html',
  styleUrls: ['./add-fiqh.component.scss']
})
export class AddFiqhComponent implements OnInit {
formData: any = {
 name: '',
  slug: '',
};
   public arrCoupons: any[] = [];
  public lang : any

    public currentLang : string
errors: any = {}; // store validation errors

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,private language : LanguageService
  ) {}

    ngOnInit(): void {
                this.currentLang = localStorage.getItem('currentLang')
   this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});


                  this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


    }
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  this.formData.image = file.name; // send only file name ✔
}


    cancel(): void {
      this.router.navigate(['/FIQH']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  this.errors = {}; // reset previous errors

 const payload = {
    // question: this.formData.question,
 name: this.formData.name,
  slug: this.formData.slug,
  };

  this.apisService.addfiqhTopic(payload).subscribe({
   next: () => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تمت الإضافة بنجاح'
      : 'Added successfully'
  );

  this.router.navigate(['/FIQH']);
},

error: () => {
  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ أثناء الإضافة'
      : 'Error adding'
  );
}

  });
}


}